const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const API = require('jiji/infra/api/user');
const AccountListView = require('jiji/ui/view/account/list');
const AccountRepository = require('jiji/domain/repository/account');
const Template = require('jiji/ui/template/content/signup/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        userName: '#user-name',
        signupButton: '.signup'
    },
    events: {
        'click @ui.signupButton': 'signup'
    },
    regions: {
        accounts: '.accounts'
    },

    onRender: function() {
        AccountRepository.getUnconnectedAccounts().then(accounts => {
            this.showChildView('accounts', new AccountListView({
                collection: new Backbone.Collection(accounts)
            }));

            this._account = accounts[0];
            this.ui.userName.val(accounts[0].getName());
        }).then(() => {
            // サインアップ画面に必要な情報が表示されたら、自動でサインアップ処理を開始する。
            // https://github.com/levii/balus-app/issues/2175
            this.signup();
        })
    },

    signup: function() {
        API.signup({
            providerName: this._account.getProviderName(),
            providerId: this._account.getProviderId(),
            name: this.ui.userName.val()
        }).then(() => {
            const params = new URLSearchParams(window.location.search);
            if(params.has('from')) {
                location.href = decodeURIComponent(params.get('from'));
            } else {
                location.href = '/';
            }
        });
    }
});



// WEBPACK FOOTER //
// ./jiji/ui/view/content/signup/index.js